<template>
  <div ref="elem" style="overflow:hidden; position: relative;"><slot name="default"></slot>
    <span class="btn"><span>展开</span></span>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref } from 'vue';

export default defineComponent({
  props: {
    rows: {
      default: 2,
      type: Number,
    },
  },
  setup(props) {
    const elem = ref(null);
    onMounted(() => {
      const lh = parseInt(window.getComputedStyle(elem.value).lineHeight, 10);
      const h = parseInt(window.getComputedStyle(elem.value).height, 10);
      if (h > lh * props.rows) {
        elem.value.style.height = `${props.rows * lh}px`;
      }
      const firstLineText = elem.value.innerText.split('\n')[0];
      console.log(firstLineText);
    });
    return {
      elem,
    };
  },
});
</script>

<style lang="scss" scoped>
.btn {
  position: absolute;
  right: 0;
  bottom: 0;
  background-color: #fff;
  background-image: linear-gradient(to right, rgba(255,255,255, 0.3) , #fff);
  width: 50px;
  text-align: right;
}
</style>
